
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"16","fill":"#525C7A","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.793 1.632a.75.75 0 00-1.5 0v.524h-3.6v-.524a.75.75 0 00-1.5 0v.524H2.027A2.025 2.025 0 000 4.179V13.094c0 1.12.908 2.024 2.026 2.024h8.932a2.025 2.025 0 002.026-2.024V4.18a2.025 2.025 0 00-2.026-2.023H9.793v-.524zm1.69 4.344V4.18a.525.525 0 00-.525-.523H9.793v.523a.75.75 0 01-1.5 0v-.523h-3.6v.523a.75.75 0 01-1.5 0v-.523H2.027a.525.525 0 00-.526.523v1.797h9.984zM1.5 7.476h9.984v5.618a.525.525 0 01-.526.524H2.026a.525.525 0 01-.526-.524V7.476z"}}),_c('path',{attrs:{"d":"M10.75 2.542H2.244c-.672 0-1.216.217-1.216.485v3.396c0 .268.544.486 1.216.486h8.506c.671 0 1.215-.218 1.215-.486V3.027c0-.268-.544-.485-1.215-.485z"}})])
          )
        }
      }
    